function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Children, createRef } from 'react';
import { debounce, safeSelect } from '@sie/web-common-utils';
import PropTypes from 'prop-types';
import classNames from '../utils/classNames';
import isRtl from '../utils/isRtl';
import Button from '../Button';
import Icon from '../Icon';
import Strand from '../Strand';
import StrandStates from '../Strand/StrandStates';
var ONE_FRAME_MS = 17;
/**
 * The SingleFrameStrand component is an instance of the Strand component that displays a
 * collection of UI items horizontally allowing the content to scroll by single frames only,
 * keeping the height consistent.
 *
 * ** Browser Support**
 *
 * This component depends on scroll-behavior and will require a polyfill for Safari
 * [Recommended PolyFill (smoothscroll-polyfill)](https://github.com/iamdustan/smoothscroll)
 * This polyfill can be loaded from  web-common browser polyfills
 *
 * **Designs**
 *
 * - [Product Strand IXD](https://atlas.np.tools.playstation.net/design/b46dafea-6646-49a9-bfb6-a9ec467c6929/1?bounds=-0.120,0.007,1.241,0.843)
 * - [Product Strand Red Lines](https://atlas.np.tools.playstation.net/design/864ab9c0-7f8e-45d4-a4b7-1dfab063ec96/1?bounds=0.379,0.673,0.385,0.262&rev=1,1,1&x=549.46,653.72,4455.94&y=809.14,3598.32,6174.10)
 * - [Editions Strand IXD](https://atlas.np.tools.playstation.net/design/f13ae03c-ae4a-433c-86db-339c1d26f71e/2?bounds=-0.206,-0.022,1.067,0.725)
 * - [Editions Strand Red Lines](https://atlas.np.tools.playstation.net/design/defebb5a-0142-4812-a676-b2fb0198f30d/5?bounds=0.344,0.412,0.515,0.368)
 * - [Single Scroll Strand - MediaCarousel IXD](https://atlas.np.tools.playstation.net/design/4cf0072e-d557-4678-a0ba-8315458f5f60/23?bounds=-0.005,2.817,0.379,0.264&rev=17,23&x=519.09,1655.26&y=28535.22,86131.17)
 * - [Single Scroll Strand - MediaCarousel Red Lines](https://atlas.np.tools.playstation.net/design/a8c8cdcf-4927-439b-b7b7-e631c7c3448d/8?bounds=0.130,0.535,0.214,0.149)
 *
 * **Usage**
 * Loading state
 *
 * ```jsx
 * <SingleFrameStrand loading loadingItem=(<div>loading...</div>)>
 * </SingleFrameStrand>
 * ```
 *
 * With inline error
 *
 * ```jsx
 * <SingleFrameStrand errorMessage="Foobar">
 * </SingleFrameStrand>
 * ```
 *
 * ```jsx
 * <SingleFrameStrand>
 *   <div>Item 1</div>
 *   <div>Item 2</div>
 *   <div>Item 3</div>
 *   <div>Item 4</div>
 *   <div>Item 5</div>
 *   <div>Item 6</div>
 *   <div>Item 7</div>
 * </SingleFrameStrand>
 * ```
 *
 * ```jsx
 * <SingleFrameStrand full itemSize="large">
 *   <div>Item 1</div>
 *   <div>Item 2</div>
 *   <div>Item 3</div>
 *   <div>Item 4</div>
 *   <div>Item 5</div>
 *   <div>Item 6</div>
 *   <div>Item 7</div>
 * </SingleFrameStrand>
 * ```
 */

var SingleFrameStrand = /*#__PURE__*/function (_Strand) {
  _inherits(SingleFrameStrand, _Strand);

  var _super = _createSuper(SingleFrameStrand);

  /* @FUTURE: reduce redundancy in methods */
  function SingleFrameStrand(props) {
    var _this;

    _classCallCheck(this, SingleFrameStrand);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "state", {
      activeFrame: -1,
      flipFactor: 1,
      focusedItem: undefined,
      hoveredItem: undefined,
      gap: 0,
      itemWidth: 0,
      pageWidth: 0
    });

    _defineProperty(_assertThisInitialized(_this), "_handleScroll", debounce(function () {
      return _this._computeScrollProgress();
    }, ONE_FRAME_MS));

    _defineProperty(_assertThisInitialized(_this), "_computeScrollProgress", function () {
      var current = _this._node.current;
      var _this$state = _this.state,
          activeFrame = _this$state.activeFrame,
          pageWidth = _this$state.pageWidth;
      if (!current) return;

      var isOnLastPage = _this._isOnLastPage();

      var itemWidth = _this._getItemWidth();

      var scrollLeft = _this._getScrollLeft();

      var scrollWidth = _this._getScrollWidth();

      var singlePageWidth = _this._getSinglePageWidth();

      if (pageWidth !== singlePageWidth) {
        _this._singleFrameScroll(activeFrame, current, true);
      }

      _this._onSeeked({
        progress: (scrollLeft + itemWidth) / scrollWidth,
        isLast: isOnLastPage,
        pageCount: Math.floor(singlePageWidth / itemWidth)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_handleTouchStart", function (event) {
      _this.touchstartX = event.touches[0].clientX;
    });

    _defineProperty(_assertThisInitialized(_this), "_handleTouchMove", function (event) {
      event.preventDefault();

      if (!_this.touchstartX) {
        return;
      }

      var xMove = event.touches[0].clientX;
      var xDiff = _this.touchstartX - xMove;
      if (xDiff > 0) _this._nextMediaFrame();
      if (xDiff < 0) _this._previousMediaFrame();
      _this.touchstartX = null;
    });

    _defineProperty(_assertThisInitialized(_this), "_handleKeyDown", function (event) {
      var current = _this._node.current;
      var key = event.key;
      var numChildren = current.children.length;
      var focusItem = Number(event.target.id.split('-')[1]);

      if (focusItem >= 0) {
        if (key === 'ArrowRight') {
          event.preventDefault();
          var nextFocusItem = focusItem + 1;

          if (nextFocusItem <= numChildren - 1) {
            current.children[nextFocusItem].focus();

            _this.setState({
              focusedItem: nextFocusItem,
              activeFrame: nextFocusItem
            });
          }
        }

        if (key === 'ArrowLeft') {
          event.preventDefault();
          var previousFocusItem = focusItem - 1;

          if (previousFocusItem >= 0) {
            current.children[previousFocusItem].focus();

            _this.setState({
              focusedItem: previousFocusItem,
              activeFrame: previousFocusItem
            });
          }
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_handleSwipeAndKeyEvents", function () {
      var current = _this._node.current;
      if (!current) return;
      current.addEventListener('touchstart', _this._handleTouchStart, false);
      current.addEventListener('touchmove', _this._handleTouchMove, false);
      current.addEventListener('keydown', _this._handleKeyDown);
    });

    _defineProperty(_assertThisInitialized(_this), "_nextMediaFrame", function () {
      var current = _this._node.current;
      if (!current) return;
      var activeFrame = _this.state.activeFrame;

      _this._singleFrameScroll(activeFrame + 1, current);
    });

    _defineProperty(_assertThisInitialized(_this), "_previousMediaFrame", function () {
      var current = _this._node.current;
      if (!current) return;
      var activeFrame = _this.state.activeFrame;

      _this._singleFrameScroll(activeFrame - 1, current);
    });

    _defineProperty(_assertThisInitialized(_this), "_singleFrameScroll", function (activeFrame, current) {
      var _this$state2 = _this.state,
          flipFactor = _this$state2.flipFactor,
          gap = _this$state2.gap,
          itemWidth = _this$state2.itemWidth,
          pageWidth = _this$state2.pageWidth;
      var useGap = gap;
      var useItemWidth = itemWidth;
      var usePageWidth = pageWidth;

      var singlePageWidth = _this._getSinglePageWidth();

      var numChildren = current.children.length;

      if (activeFrame >= numChildren || activeFrame < 0) {
        return;
      }

      if (pageWidth !== singlePageWidth) {
        useGap = _this._getGutter();
        useItemWidth = _this._getItemWidth();
        usePageWidth = singlePageWidth;
      }

      var activeItemWidth = useItemWidth * 1.2;
      var activeItemWithGap = activeItemWidth + useGap;
      var itemWithGap = useItemWidth + useGap;
      var maxWholeItemWidths = Math.floor((usePageWidth - activeItemWithGap) / itemWithGap);
      var nonActiveItemsWithGap = maxWholeItemWidths * itemWithGap - useGap;
      var partialItemWidthOnPage = usePageWidth - (activeItemWithGap + nonActiveItemsWithGap);
      var scrollLeftRemainder = useItemWidth - partialItemWidthOnPage / 2;
      var wholeScrollWidth = (numChildren - 1) * itemWithGap + activeItemWidth - useGap;
      var lastPageLeftScroll = wholeScrollWidth - (maxWholeItemWidths * itemWithGap + activeItemWidth);
      var activeFramePosition = (activeFrame - 1) * itemWithGap + activeItemWithGap;
      var firstPageMiddlePosition = usePageWidth / 2 - activeItemWidth / 2;
      var lastPageMiddlePosition = lastPageLeftScroll + (usePageWidth / 2 - useItemWidth / 2 + useGap);
      var shouldStrandScroll = wholeScrollWidth > usePageWidth;

      if (activeFramePosition > firstPageMiddlePosition && activeFramePosition < lastPageMiddlePosition && shouldStrandScroll) {
        var framesBeforeCurrentPage = activeFrame - 1 - maxWholeItemWidths / 2;
        var scrollLeft = framesBeforeCurrentPage * itemWithGap + (scrollLeftRemainder + gap);
        var newScrollLeft = flipFactor === 1 ? scrollLeft : (numChildren - 1 - framesBeforeCurrentPage) * itemWithGap;

        _this.setState({
          activeFrame: activeFrame,
          gap: useGap,
          itemWidth: useItemWidth,
          pageWidth: usePageWidth
        });

        current.scrollTo({
          top: 0,
          left: Math.round(newScrollLeft),
          behavior: 'smooth'
        });
      }

      if (activeFramePosition < firstPageMiddlePosition && shouldStrandScroll) {
        var _newScrollLeft = flipFactor === 1 ? 0 : lastPageLeftScroll;

        _this.setState({
          activeFrame: activeFrame
        });

        current.scrollTo({
          top: 0,
          left: Math.round(_newScrollLeft),
          behavior: 'smooth'
        });
      }

      if (activeFramePosition > lastPageMiddlePosition && shouldStrandScroll) {
        var _newScrollLeft2 = flipFactor === 1 ? lastPageLeftScroll : 0;

        _this.setState({
          activeFrame: activeFrame
        });

        current.scrollTo({
          top: 0,
          left: Math.round(_newScrollLeft2),
          behavior: 'smooth'
        });
      }

      if (!shouldStrandScroll) {
        _this.setState({
          activeFrame: activeFrame
        });
      }

      _this._setFocusedItem(activeFrame);
    });

    _this._node = /*#__PURE__*/createRef();
    _this._parentNode = /*#__PURE__*/createRef();
    _this._computeScrollProgress = _this._computeScrollProgress.bind(_assertThisInitialized(_this));
    _this._getItemWidth = _this._getItemWidth.bind(_assertThisInitialized(_this));
    _this._getItemWidthClasses = _this._getItemWidthClasses.bind(_assertThisInitialized(_this));
    _this._handleScroll = _this._handleScroll.bind(_assertThisInitialized(_this));
    _this._isOnFirstPage = _this._isOnFirstPage.bind(_assertThisInitialized(_this));
    _this._isOnLastPage = _this._isOnLastPage.bind(_assertThisInitialized(_this));
    _this._handleSwipeAndKeyEvents = _this._handleSwipeAndKeyEvents.bind(_assertThisInitialized(_this));
    _this.touchstartX = 0;
    return _this;
  }

  _createClass(SingleFrameStrand, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var onUpdate = this.props.onUpdate;
      var flipFactor = isRtl() ? -1 : 1;

      var gap = this._getGutter();

      var isFrameOffset = false;

      var itemWidth = this._getItemWidth();

      var pageWidth = this._getSinglePageWidth();

      this.setState({
        flipFactor: flipFactor,
        gap: gap,
        isFrameOffset: isFrameOffset,
        itemWidth: itemWidth,
        pageWidth: pageWidth
      });
      window.addEventListener('resize', this._computeScrollProgress);

      this._computeScrollProgress();

      this._handleSwipeAndKeyEvents();

      if (typeof onUpdate === 'function') {
        onUpdate(this.state);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var current = this._node.current;
      if (!current) return;
      var currentActiveFrame = this.state.focusedItem;
      var previousActiveFrame = prevState.focusedItem;
      var wasLoading = prevProps.loading,
          previousSelectedFrame = prevProps.selectedFrame;
      var _this$props = this.props,
          isLoadingNow = _this$props.loading,
          onUpdate = _this$props.onUpdate,
          currentSelectedFrame = _this$props.selectedFrame;

      if (wasLoading !== isLoadingNow) {
        this._computeScrollProgress();

        this._handleSwipeAndKeyEvents();
      } // The below logic is to keep the pagination buttons in sync with the singleFrame strand


      var isSelectedFrame = previousSelectedFrame !== currentSelectedFrame && currentActiveFrame !== currentSelectedFrame;
      if (isSelectedFrame) this._singleFrameScroll(currentSelectedFrame, current);
      var isActiveFrame = previousActiveFrame !== currentActiveFrame && currentActiveFrame !== currentSelectedFrame;
      if (typeof onUpdate === 'function' && isActiveFrame) onUpdate(this.state);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var current = this._node.current;
      window.removeEventListener('resize', this._computeScrollProgress);
      current.removeEventListener('touchstart', this._handleTouchStart);
      current.removeEventListener('touchmove', this._handleTouchMove);
      current.removeEventListener('keydown', this._handleKeyDown);
    }
    /**
     * Set values of _onSeeked for scroll progress, including parameters if
     * the page has been resized.
     */

  }, {
    key: "_getLastItem",

    /**
     * Get last DOM element of <ul> ref
     * @returns {HTMLElement} lastElementChild
     */
    value: function _getLastItem() {
      var current = this._node.current;
      return safeSelect(current, 'lastElementChild');
    }
    /**
     * Get the width of non-active <li> elements of <ul>
     * @returns {number}
     */

  }, {
    key: "_getItemWidth",
    value: function _getItemWidth() {
      var _current$children, _current$children2, _current$children3, _current$children4;

      var current = this._node.current;
      var numChildren = (current === null || current === void 0 ? void 0 : (_current$children = current.children) === null || _current$children === void 0 ? void 0 : _current$children.length) || 0;
      var middleChild = Math.floor(numChildren / 2);

      var firstItemWidth = this._getCssDimension(current === null || current === void 0 ? void 0 : (_current$children2 = current.children) === null || _current$children2 === void 0 ? void 0 : _current$children2[0], 'width');

      var middleChildWidth = this._getCssDimension(current === null || current === void 0 ? void 0 : (_current$children3 = current.children) === null || _current$children3 === void 0 ? void 0 : _current$children3[middleChild], 'width');

      var lastItemWidth = this._getCssDimension(current === null || current === void 0 ? void 0 : (_current$children4 = current.children) === null || _current$children4 === void 0 ? void 0 : _current$children4[numChildren - 1], 'width');

      return [firstItemWidth, middleChildWidth || firstItemWidth, lastItemWidth || firstItemWidth].sort(function (a, b) {
        return a - b;
      })[0];
    }
  }, {
    key: "_getItemWidthClasses",
    value: function _getItemWidthClasses() {
      var expand = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var itemSize = this.props.itemSize;
      var active = expand ? 'active-' : '';

      if (itemSize === 'carousel') {
        return classNames("psw-grid-".concat(active, "three-for-four"), "psw-grid-".concat(active, "five-for-twelve-at-tablet-s"), "psw-grid-".concat(active, "five-for-twelve-at-tablet-l"), "psw-grid-".concat(active, "one-for-four-at-laptop"), "psw-grid-".concat(active, "one-for-four-at-desktop"), "psw-grid-".concat(active, "one-for-four-at-max"));
      }

      if (itemSize === 'medium') {
        return classNames("psw-grid-".concat(active, "one-for-two"), "psw-grid-".concat(active, "one-for-three-at-tablet-s"), "psw-grid-".concat(active, "one-for-four-at-tablet-l"), "psw-grid-".concat(active, "one-for-six-at-laptop"), "psw-grid-".concat(active, "one-for-six-at-desktop"), "psw-grid-".concat(active, "one-for-six-at-max"));
      }

      if (itemSize === 'small') {
        return classNames("psw-grid-".concat(active, "one-for-two"), "psw-grid-".concat(active, "one-for-four-at-tablet-s"), "psw-grid-".concat(active, "one-for-six-at-tablet-l"), "psw-grid-".concat(active, "one-for-six-at-laptop"), "psw-grid-".concat(active, "one-for-eight-at-desktop"), "psw-grid-".concat(active, "one-for-eight-at-max"));
      }

      return classNames("psw-grid-".concat(active, "1/1"), "psw-grid-".concat(active, "one-for-two-at-tablet-s"), "psw-grid-".concat(active, "one-for-three-at-tablet-l"), "psw-grid-".concat(active, "one-for-three-at-laptop"), "psw-grid-".concat(active, "one-for-three-at-desktop"), "psw-grid-".concat(active, "one-for-three-at-max"));
    }
    /**
     * Scroll \<SingleFrameStrand> to previous child element if the elements in view
     * have not reached their starting position. Also sets the activeFrame.
     */

  }, {
    key: "_shouldStrandScroll",

    /**
     * Determine if the total scroll width is larger thatn page width
     * @returns boolean
     */
    value: function _shouldStrandScroll() {
      var _current$children5;

      var current = this._node.current;
      if (!current) return true;
      var singleItemWIdth = current === null || current === void 0 ? void 0 : (_current$children5 = current.children) === null || _current$children5 === void 0 ? void 0 : _current$children5[0].offsetWidth;
      var numChildren = current.children.length;

      var wholeScrollWidth = this._getCssDimension(this._parentNode.current, 'width');

      var allItemsScrollWidth = numChildren * singleItemWIdth;
      var shouldStrandScroll = wholeScrollWidth < allItemsScrollWidth;
      return shouldStrandScroll;
    }
    /**
     * Set state attribute `focusedItem` when tabbing through and out of elements
     * @param {(number | undefined)} idx - the the value of the element on focus and on blur
     */

  }, {
    key: "_setFocusedItem",
    value: function _setFocusedItem() {
      var idx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      this.setState({
        focusedItem: idx
      });
    }
    /**
     * Set focused element and unset hovered element on focus
     * @param {number} idx - the the value of the element on focus
     */

  }, {
    key: "_setFocusedNotHovered",
    value: function _setFocusedNotHovered() {
      var idx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this._setFocusedItem(idx);

      this._setHoveredItem(undefined);
    }
    /**
     * Set state attribute `hoveredItem` when mousing over and out of elements
     * @param {(number | undefined)} idx - the value of the hovered element on mouseover and mouseout
     */

  }, {
    key: "_setHoveredItem",
    value: function _setHoveredItem() {
      var idx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      this.setState({
        hoveredItem: idx
      });
    }
    /**
     * Set hovered element and unset focused element on hover
     * @param {number} idx - the value of the hovered element on mouseover
     */

  }, {
    key: "_setHoveredNotFocused",
    value: function _setHoveredNotFocused() {
      var idx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this._setHoveredItem(idx);
    }
    /**
     * Set tabIndex for isSingleScroll so that tabbing members of the \<SingleFrameStrand>
     * does not cause \<SingleFrameStrand> to scroll without interacting with previous and
     * next \<button> elements
     * @param {number} idx - index of \<SingleFrameStrand> child
     * @return {number} - 0 or -1 to control tabindex
     */

  }, {
    key: "_setTabIndex",
    value: function _setTabIndex() {
      var idx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var current = this._node.current;
      if (!current) return -1;
      var tabIndex = -1;
      var _this$state3 = this.state,
          activeFrame = _this$state3.activeFrame,
          gap = _this$state3.gap,
          itemWidth = _this$state3.itemWidth,
          pageWidth = _this$state3.pageWidth;
      var activeItemWidth = itemWidth * 1.2;
      var activeItemWithGap = activeItemWidth + gap;
      var itemWithGap = itemWidth + gap;
      var maxWholeItemWidths = Math.floor((pageWidth - activeItemWithGap) / itemWithGap);
      var numChildren = current.children.length;
      var numElementsBeforeActiveElement = Math.round((maxWholeItemWidths - 1) / 2);
      var wholeScrollWidth = (numChildren - 1) * itemWithGap + activeItemWidth - gap;
      var lastPageLeftScroll = wholeScrollWidth - (maxWholeItemWidths * itemWithGap + activeItemWidth);
      var activeFramePosition = (activeFrame - 1) * itemWithGap + activeItemWithGap;
      var firstPageMiddlePosition = pageWidth / 2 - activeItemWidth / 2;
      var lastPageMiddlePosition = lastPageLeftScroll + (pageWidth / 2 - itemWidth / 2 + gap);
      var nextTabElements = idx === activeFrame || idx === activeFrame + 1 || idx === activeFrame - 1 ? 0 : -1;

      if (activeFramePosition > firstPageMiddlePosition && activeFramePosition < lastPageMiddlePosition) {
        if (numElementsBeforeActiveElement) {
          tabIndex = idx === activeFrame || idx >= activeFrame - numElementsBeforeActiveElement && idx <= activeFrame + numElementsBeforeActiveElement ? 0 : -1;
        } else {
          tabIndex = nextTabElements;
        }
      }

      if (activeFramePosition < firstPageMiddlePosition) {
        tabIndex = idx <= maxWholeItemWidths ? 0 : -1;
      }

      if (activeFramePosition > lastPageMiddlePosition) {
        tabIndex = idx >= numChildren - maxWholeItemWidths - 1 ? 0 : -1;
      }

      if (pageWidth < activeItemWithGap + itemWithGap) {
        tabIndex = nextTabElements;
      }

      if (!this._shouldStrandScroll()) {
        tabIndex = 0;
      }

      return tabIndex;
    }
    /**
     * Return boolean to indicate if scroll functionality
     * has reached its initial position
     * @return {boolean}
     */

  }, {
    key: "_isOnFirstPage",
    value: function _isOnFirstPage() {
      var current = this._node.current;
      var activeFrame = this.state.activeFrame;
      return current ? activeFrame <= 0 : true;
    }
    /**
     * Return boolean to indicate if scroll functionality has
     * reached its final position
     * @return {boolean}
     */

  }, {
    key: "_isOnLastPage",
    value: function _isOnLastPage() {
      var current = this._node.current;
      if (!current) return true;
      var activeFrame = this.state.activeFrame;
      return activeFrame + 1 === current.children.length;
    }
    /**
     * Scroll <Strand> when Enter key is used on next \<button>
     */

  }, {
    key: "_onNextKeyUp",
    value: function _onNextKeyUp(event) {
      var nextMediaFrame = this.props.nextMediaFrame;
      if (event.key === 'Enter') nextMediaFrame();
    }
    /**
     * Scroll <Strand> when Enter key is used on previous \<button>
     */

  }, {
    key: "_onPrevKeyUp",
    value: function _onPrevKeyUp(event) {
      var previousMediaFrame = this.props.previousMediaFrame;
      if (event.key === 'Enter') previousMediaFrame();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state4 = this.state,
          activeFrame = _this$state4.activeFrame,
          focusedItem = _this$state4.focusedItem,
          hoveredItem = _this$state4.hoveredItem;
      var _this$props2 = this.props,
          qa = _this$props2.qa,
          children = _this$props2.children,
          full = _this$props2.full,
          itemSize = _this$props2.itemSize,
          previousControlLabel = _this$props2.previousControlLabel,
          nextControlLabel = _this$props2.nextControlLabel,
          loading = _this$props2.loading,
          errorMessage = _this$props2.errorMessage,
          loadingItem = _this$props2.loadingItem;
      var childrenArray = Children.toArray(children);
      var isLoading = loading || errorMessage;

      var shouldStrandScroll = this._shouldStrandScroll();

      if (isLoading) {
        return /*#__PURE__*/React.createElement(StrandStates, {
          qa: qa,
          full: full,
          itemWidth: this._getItemWidthClasses(),
          loading: loading,
          errorMessage: errorMessage,
          loadingItem: loadingItem,
          singleFrame: true
        });
      }

      if (!isLoading && childrenArray.length === 0) return null;
      return /*#__PURE__*/React.createElement("div", {
        id: "single-frame-strand",
        "data-qa": qa,
        className: classNames('psw-strand', 'psw-l-anchor', 'psw-l-line-center', "psw-with-".concat(itemSize, "-items")),
        onScroll: this._handleScroll,
        ref: this._parentNode
      }, !this._isOnFirstPage() && shouldStrandScroll && /*#__PURE__*/React.createElement("div", {
        className: classNames('psw-strand-controls', 'psw-l-anchor-top-center', 'psw-l-top-center', 'psw-l-align-center', 'psw-pointer-events-off', 'psw-l-w-1/1', 'psw-l-line-center', 'psw-fill', 'psw-l-z-1')
      }, /*#__PURE__*/React.createElement("div", {
        className: classNames('psw-l-anchor-center-left', 'psw-pointer-events-on', 'psw-l-inline')
      }, /*#__PURE__*/React.createElement(Button, {
        ariaLabel: previousControlLabel,
        ctaType: "primary",
        iconOnly: true,
        onClick: this._previousMediaFrame,
        onKeyUp: function onKeyUp(event) {
          return _this2._onPrevKeyUp(event);
        },
        qa: "".concat(qa, "#previous")
      }, /*#__PURE__*/React.createElement(Icon, {
        type: "chevron-left"
      })))), /*#__PURE__*/React.createElement("div", {
        className: classNames('psw-l-anchor', 'psw-l-section', 'psw-l-z-0')
      }, /*#__PURE__*/React.createElement("ul", {
        ref: this._node,
        className: classNames('psw-hide-scrollbar', 'psw-l-align-center', 'psw-l-line-left', 'psw-l-space-x-5', 'psw-list-style-none', 'psw-strand-scroller', 'psw-single-frame', 'psw-p-t-1', 'psw-p-b-1'),
        tabIndex: -1
      }, childrenArray.map(function (x, i) {
        return /*#__PURE__*/React.createElement("li", {
          className: classNames('psw-p-2', 'psw-l-line-left-top', 'psw-single-frame-child', _this2._getItemWidthClasses(focusedItem === i)),
          id: "item-".concat(i),
          "data-qa": "".concat(qa, "#item").concat(i),
          key: safeSelect(x, 'props.id') || i,
          onBlur: function onBlur(event) {
            var _event$relatedTarget;

            if (((_event$relatedTarget = event.relatedTarget) === null || _event$relatedTarget === void 0 ? void 0 : _event$relatedTarget.id.toLowerCase().indexOf('media-carousel')) === -1 && (activeFrame === childrenArray.length - 1 || activeFrame === 0)) {
              _this2._setFocusedItem();
            }
          },
          onFocus: function onFocus() {
            if (i === 0 && activeFrame === -1) {
              _this2.setState({
                activeFrame: activeFrame + 1
              });

              _this2._setFocusedItem(activeFrame + 1);
            } else {
              if (i > 0) _this2._nextMediaFrame();
              if (activeFrame > i) _this2._previousMediaFrame();

              _this2._setFocusedItem(i);
            }
          },
          onMouseOut: function onMouseOut() {
            return _this2._setHoveredItem(undefined);
          },
          onMouseOver: function onMouseOver() {
            return _this2._setHoveredNotFocused(i);
          },
          style: hoveredItem === i && activeFrame !== i ? {
            transform: 'scale(1.05)'
          } : {},
          tabIndex: _this2._setTabIndex(i)
        }, x);
      }))), !this._isOnLastPage() && shouldStrandScroll && /*#__PURE__*/React.createElement("div", {
        className: classNames('psw-strand-controls', 'psw-l-anchor-top-center', 'psw-l-top-center', 'psw-l-align-center', 'psw-pointer-events-off', 'psw-l-w-1/1', 'psw-l-line-center', 'psw-fill', 'psw-l-z-1')
      }, /*#__PURE__*/React.createElement("div", {
        className: classNames('psw-l-anchor-center-right', 'psw-pointer-events-on', 'psw-l-inline', 'psw-l-z-1')
      }, /*#__PURE__*/React.createElement(Button, {
        ariaLabel: nextControlLabel,
        ctaType: "primary",
        iconOnly: true,
        onClick: this._nextMediaFrame,
        onKeyUp: function onKeyUp(event) {
          return _this2._onNextKeyUp(event);
        },
        qa: "".concat(qa, "#next")
      }, /*#__PURE__*/React.createElement(Icon, {
        type: "chevron-right"
      })))));
    }
  }]);

  return SingleFrameStrand;
}(Strand);

SingleFrameStrand.defaultProps = {
  children: null,
  errorMessage: '',
  itemSize: 'medium',
  loading: false,
  loadingItem: null,
  nextControlLabel: '',
  onNext: function onNext() {},
  onPrevious: function onPrevious() {},
  onSeeked: function onSeeked() {},
  onUpate: function onUpate() {},
  previousControlLabel: '',
  qa: 'singleFrameStrand'
};
Strand.propTypes = {
  /**
   * The collection of items to render into the strand
   */
  children: PropTypes.oneOf([PropTypes.arrayOf(PropTypes.object), PropTypes.arrayOf(PropTypes.node), PropTypes.instanceOf(null)]),

  /**
   * The inline error message to display of the space maintained for the strand
   */
  errorMessage: PropTypes.node,

  /**
   * The relative size (based on width) of the items
   */
  itemSize: PropTypes.oneOf(['carousel', 'small', 'medium', 'large']),

  /**
   * Whether the strand should be shown in a loading state
   */
  loading: PropTypes.bool,

  /**
   * The loading UI to show per placeholder item in the strand
   */
  loadingItem: PropTypes.node,

  /**
   * Screen reader label for the next control button
   */
  nextControlLabel: PropTypes.string,

  /**
   * Event callback called when the next control is interacted with (will  not be called
   * for pure scrolling / swiping)
   */
  onNext: PropTypes.func,

  /**
   * Event callback called when the previous control is interacted with (will  not be called
   * for pure scrolling / swiping)
   */
  onPrevious: PropTypes.func,

  /**
   * Event callback, called when the content has been scrolled (roughly once per page
   * but not guarenteed)
   */
  onSeeked: PropTypes.func,

  /**
   * Event callback called to pass state data to parent element from Strand
   */
  onUpdate: PropTypes.func,

  /**
   * Screen reader label for the previous control button
   */
  previousControlLabel: PropTypes.string,

  /**
   * Unique id used for qa automation. This should be unique to the page
   */
  qa: PropTypes.string,

  /**
   * Selected item from pagination
   */
  selectedFrame: PropTypes.number
};
export default SingleFrameStrand;